"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GenericCollection_1 = __importDefault(require("./GenericCollection"));
class GenericMapObjectCollection extends GenericCollection_1.default {
    constructor(features, attributes) {
        super(features, attributes);
        this._idByIntegerId = new Map();
        this._idByIntegerId = new Map();
        this.updateIndexes();
    }
    getFeatureId(feature) {
        return feature.properties.id;
    }
    get length() {
        return this._features.length;
    }
    setFeatures(features) {
        this._features = features;
        this.updateIndexes();
    }
    size() {
        return this._features.length;
    }
    updateIndexes() {
        super.updateIndexes();
        if (this._idByIntegerId) {
            this.updateIdByIntegerId();
        }
    }
    isObject(feature) {
        return 'toGeojson' in feature;
    }
    updateById(featureId, updatedFeature) {
        const geojsonFeature = this.isObject(updatedFeature)
            ? updatedFeature.toGeojson()
            : updatedFeature;
        super.updateById(featureId, geojsonFeature);
    }
    add(feature) {
        const geojsonFeature = this.isObject(feature) ? feature.toGeojson() : feature;
        super.add(geojsonFeature);
    }
    updateFeature(feature) {
        const geojsonFeature = this.isObject(feature) ? feature.toGeojson() : feature;
        super.updateFeature(geojsonFeature);
    }
    updateIdByIntegerId() {
        this._idByIntegerId.clear();
        for (let i = 0, count = this.size(); i < count; i++) {
            const feature = this.features[i];
            if (feature.properties && feature.properties.id && feature.properties.integer_id) {
                this._idByIntegerId.set(feature.properties.integer_id, feature.properties.id);
            }
        }
    }
    getIdByIntegerId(featureIntegerId) {
        return this._idByIntegerId.get(featureIntegerId);
    }
    toGeojson() {
        return {
            type: 'FeatureCollection',
            features: this.features
        };
    }
}
exports.default = GenericMapObjectCollection;
//# sourceMappingURL=GenericMapObjectCollection.js.map